import { isServerSideRendering } from '../../../utils/gatsby';
export function isBotpressLoaded() {
  return !isServerSideRendering() && window.botpress;
}
export function isBotpressInitialized() {
  return isBotpressLoaded() && window.botpress.initialized;
}
export function isBotpressConversationReady() {
  return isBotpressInitialized() && window.botpress.conversationReady;
}